// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__3JghX","Label":"Checkbox_Label__2Epba","InputElement":"Checkbox_InputElement__1hiF0","Invalid":"Checkbox_Invalid__1XHf7"};